<template>
	<div class="ayuda" v-if="!is_mobile">
		<div class="libe_home_nav animate__animated animate__fadeInDown" v-if="scroll >= 88">
			<headNav :activeNav="'ayuda'"></headNav>
		</div>
		<div class="eshoy_content_wrap">
			<div class="libe_homenav" v-if="scroll < 88">
				<homeNav :activeNav="'ayuda'"></homeNav>
			</div>

			<div class="libe_home_banner">
				<div class="libe_home_banner_img">
					<img src="../assets/imgs/about_banner01.png" alt="" />
				</div>
			</div>

			<div class="eshoy_about_wrap pla_about_wrap">
				<div class="common_problem_wrap">
					<van-collapse :border="hasborder" :accordion="isaccordion" v-model="activeNames" @change="collapseChange">
						<van-collapse-item :border="hasborder" name="2">
							<template #title>
								<div class="common_title_wrap">
									<div class="common_title_left">
										<div class="common_tleft_icon">
											<img v-if="collapseIsOpen('2')" src="../assets/imgs/common_icon_02_active.png" alt="" />
											<img v-else src="../assets/imgs/common_icon_02.png" alt="" />
										</div>
										<div class="common_tleft_text" :class="collapseIsOpen('2') ? 'isopen' : ''">
											Materiales de solicitud
										</div>
									</div>
								</div>
							</template>

							<template #right-icon>
								<div class="common_title_right">
									<div class="common_trview">
										<img v-if="collapseIsOpen('2')" src="../assets/imgs/arrow_icon_up.png" alt="" />
										<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
									</div>
								</div>
							</template>

							<div class="common_children_wrap">
								<div class="children_cont_items">
									<div class="children_cont_text">
										Tener tu INE a la mano y una tarjeta bancaria de cuenta débito de CUALQUIER banco y que esté a TU
										nombre.
									</div>
								</div>
							</div>
						</van-collapse-item>

						<van-collapse-item :border="hasborder" name="3">
							<template #title>
								<div class="common_title_wrap">
									<div class="common_title_left">
										<div class="common_tleft_icon">
											<img v-if="collapseIsOpen('3')" src="../assets/imgs/common_icon_03_active.png" alt="" />
											<img v-else src="../assets/imgs/common_icon_03.png" alt="" />
										</div>
										<div class="common_tleft_text" :class="collapseIsOpen('3') ? 'isopen' : ''">Preguntas de pago</div>
									</div>
								</div>
							</template>

							<template #right-icon>
								<div class="common_title_right">
									<div class="common_trview">
										<img v-if="collapseIsOpen('3')" src="../assets/imgs/arrow_icon_up.png" alt="" />
										<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
									</div>
								</div>
							</template>

							<div class="common_children_wrap">
								<van-collapse :border="hasborder" v-model="chidtwo_Names">
									<van-collapse-item :border="hasborder" name="1">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidtwoIsOpen('1')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">¿Cómo pagar préstamo desde la App de su banco?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>

										<div class="children_cont">
											<div class="children_cont_items">1) Abre Pla Pla y copia la referencia de pago en la App.</div>
											<div class="children_cont_items">
												2) Abre la App de tu banco y selecciona una cuenta o tarjeta para pagar.
											</div>
											<div class="children_cont_items">
												3) Ingresa el beneficiario e importe (Recomendamos que guardes contacto para tu próximo
												préstamo).
											</div>
											<div class="children_cont_items">
												4) ¡Pago exitoso! Puedes volver a Pla Pla y ver el estado de la actualización.
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="2">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidtwoIsOpen('2')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">¿Qué hago cuando mi pago está fallado?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>
										<div class="children_cont">
											<div class="children_cont_items">
												Primero, confirma que la referencia de pago ingresada es correcta. Y si la referencia es
												correcta y tu pago aún no se ve reflejado, por favor, guardan los comprobantes de pago y marca a
												nuestro servicio de atención al cliente 3317133531 o enviarnos un correo electrónico
												plaplaprestamos@gmail.com.
											</div>
										</div>
									</van-collapse-item>
								</van-collapse>
							</div>
						</van-collapse-item>

						<van-collapse-item :border="hasborder" name="4">
							<template #title>
								<div class="common_title_wrap">
									<div class="common_title_left">
										<div class="common_tleft_icon">
											<img v-if="collapseIsOpen('4')" src="../assets/imgs/common_icon_04_active.png" alt="" />
											<img v-else src="../assets/imgs/common_icon_04.png" alt="" />
										</div>
										<div class="common_tleft_text" :class="collapseIsOpen('4') ? 'isopen' : ''">
											Preguntas en proceso de solicitud
										</div>
									</div>
								</div>
							</template>

							<template #right-icon>
								<div class="common_title_right">
									<div class="common_trview">
										<img v-if="collapseIsOpen('4')" src="../assets/imgs/arrow_icon_up.png" alt="" />
										<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
									</div>
								</div>
							</template>

							<div class="common_children_wrap">
								<van-collapse :border="hasborder" v-model="chidthr_Names">
									<van-collapse-item :border="hasborder" name="1">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidthrIsOpen('1')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">¿Cómo puedo solicitar mi primer préstamo?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>

										<div class="children_cont">
											<div class="children_cont_items">
												Entre a la app, regístrete con tu número telefónico (Le recomendamos crear una contraseña a la
												vez) y empieza a solicitar su préstamo. Después de la autorización, de clic en el botón de
												¨CONFIRMAR¨, el préstamo llegará a tu cuenta bancaria.
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="2">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidthrIsOpen('2')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">¿Cómo puedo solicitar de nuevo un préstamo?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>

										<div class="children_cont">
											<div class="children_cont_items">
												Una vez que se acredite tu pago podrás solicitar un segundo préstamo ¡de inmediato! Y esta vez
												disfrutarás de un monto mayor con un costo menor. Si le rechazaron tu última solicitud, puedes
												volver a solicitar después de 7 días.
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="3">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidthrIsOpen('3')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">¿Puedo tener otro préstamo mientras tengo uno activo?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>

										<div class="children_cont">
											<div class="children_cont_items">
												Lamentablemente no puede pedir otro préstamo mientras tiene uno activo. Deberá liquidar su
												préstamo activo para poder solicitar otro. Eso sí, una vez que liquide, podrá solicitar otro de
												forma inmedia
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="4">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidthrIsOpen('4')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">
														¿Cuanto tiempo tengo para confirmar mi préstamo en la App?
													</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>

										<div class="children_cont">
											<div class="children_cont_items">
												Le quedan 72 horas para confirmar tu préstamo. Le recomendamos dar clic en ¨CONFIRMAR¨ lo antes
												posible.
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="5">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidthrIsOpen('5')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">¿Cuánto tiempo tardan en depositar?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>

										<div class="children_cont">
											<div class="children_cont_items">
												Una vez que está aprobado el depósito se manda en unos minutos, sin embargo, como los horarios
												bancarios en México son de Lunes a Viernes de 9 a 5 (excepto días festivos), el depósito podría
												tardar un poco en reflejarlo en tu cuenta.
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="6">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidthrIsOpen('6')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">
														¿Cómo usan la información que lleno en la solicitud de préstamo?
													</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>

										<div class="children_cont">
											<div class="children_cont_items">
												Pla Pla usa tus datos para determinar si eres candidato a un préstamo de nuestra app. Toda tu
												información se encuentra segura y protegida. Nunca proporcionaremos tu información a terceros
												sin su permiso. Puedes leer nuestro Aviso de Privacidad dentro de la app.
											</div>
										</div>
									</van-collapse-item>
								</van-collapse>
							</div>
						</van-collapse-item>

						<van-collapse-item :border="hasborder" name="1">
							<template #title>
								<div class="common_title_wrap">
									<div class="common_title_left">
										<div class="common_tleft_icon">
											<img v-if="collapseIsOpen('1')" src="../assets/imgs/common_icon_01_active.png" alt="" />
											<img v-else src="../assets/imgs/common_icon_01.png" alt="" />
										</div>
										<div class="common_tleft_text" :class="collapseIsOpen('1') ? 'isopen' : ''">
											Preguntas generales
										</div>
									</div>
								</div>
							</template>

							<template #right-icon>
								<div class="common_title_right">
									<div class="common_trview">
										<img v-if="collapseIsOpen('1')" src="../assets/imgs/arrow_icon_up.png" alt="" />
										<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
									</div>
								</div>
							</template>

							<div class="common_children_wrap">
								<van-collapse :border="hasborder" v-model="chidone_Names">
									<van-collapse-item :border="hasborder" name="1">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidoneIsOpen('1')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">Me rechazaron mi préstamo, ¿qué hago?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>

										<div class="children_cont">
											<div class="children_cont_items">
												Lamentamos que tu solicitud haya sido rechazada; esto significa que no podrás utilizar nuestros
												servicios por ahora. Normalmente se deben a tres motivos:
											</div>
											<div class="children_cont_items">1) Confirma que todos sus datos son correctos.</div>
											<div class="children_cont_items">2) Tu monto acumulado excede el máximo permitido del mes.</div>
											<div class="children_cont_items">
												3) Tu puntaje de crédito no es suficiente. ¡Pero, no te preocupe! Puede intentar volver a
												solicitar 7 días!
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="2">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidoneIsOpen('2')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">
														Mi solicitud ha sido aprobada en la App, pero el dinero no llegó a mi cuenta bancaria. ¿Qué
														hago?
													</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>
										<div class="children_cont">
											<div class="children_cont_items">
												Las transferencias interbancarias pueden tardar al máximo 20 minutos. Si pasa esta hora y aún no
												ha recibido el préstamo, por favor contáctenos. Daremos prioridad a su consulta y le ayudaremos
												a resolverlo. Gracias por su comprensión y confianza.
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="3">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidoneIsOpen('3')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">
														Realicé el pago, sin embargo, no se ve reflejado en la App. ¿Qué hago?
													</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>
										<div class="children_cont">
											<div class="children_cont_items">
												Hay retraso en transferencia interbancaria, gracias por su paciencia. Pero si pasa UNA HORA y
												aún no se ve reflejado en la App, podrías marcar a la atención al cliente adjuntando tu
												comprobante de pago con clave rastreo.
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="4">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidoneIsOpen('4')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">Accidentalmente pagué en exceso, ¿qué hago?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>
										<div class="children_cont">
											<div class="children_cont_items">
												No te preocupes, el dinero en exceso se depositará automáticamente en el saldo de tu cuenta en
												Pla Pla. Puedes contactar con la atención al cliente para pagar tu próximo préstamo con tu
												saldo.
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="5">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidoneIsOpen('5')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">Hay falla en la App, ¿qué hago?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>
										<div class="children_cont">
											<div class="children_cont_items">
												Lamentamos que se haya encontrado con este problema. Puede enviar las singientes informaciones
												al correo de atención al cliente para verificar (plaplaprestamos@gmail.com):
											</div>
											<div class="children_cont_items">1) Número telefónico</div>
											<div class="children_cont_items">2) Modelo celular</div>
											<div class="children_cont_items">3) Captura de pantalla del probelma</div>
											<div class="children_cont_items">4) Descripción del problema</div>
											<div class="children_cont_items">
												Agradecemos muchos por sus preguntas, que nos ayudan a seguir mejorando la App y brindarle una
												mejor experiencia.
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="6">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidoneIsOpen('6')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">Quiero cambiar mi cuenta bancaria, ¿qué hago?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>
										<div class="children_cont">
											<div class="children_cont_items">
												Si no tiene ningún pedido pendiente, puede modificar la cuenta bancaria en tres lugares en Pla
												Pla:
											</div>
											<div class="children_cont_items">
												1)Entrar en la pagina de "Yo", luego da clic en "Mi tarjeta"
											</div>
											<div class="children_cont_items">2)Entrar en la pagina de "Yo", luego da clic en "Mi perfil"</div>
											<div class="children_cont_items">
												3)Entrar en la pagina de "Confirmar tu prestamo", luego da clic en "Cuenta bancaria"
											</div>
										</div>
									</van-collapse-item>

									<van-collapse-item :border="hasborder" name="7">
										<template #title>
											<div class="children_title_wrap">
												<div class="children_title_left">
													<div class="children_tleft_icon">
														<img v-if="chidoneIsOpen('7')" src="../assets/imgs/arrow_icon_up.png" alt="" />
														<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
													</div>
													<div class="children_tleft_text">Quiero cambiar mi número de teléfono, ¿qué hago?</div>
												</div>
											</div>
										</template>

										<template #right-icon>
											<div class="children_right"></div>
										</template>
										<div class="children_cont">
											<div class="children_cont_items">
												Si quieres cambiar número telefónico, por favor, las sigientes información a la atención al
												cliente:
											</div>
											<div class="children_cont_items">
												1) Fotos de identificación que has subido para registrarte la cuenta Pla Pla (Para verificar si
												eres la misma persona)
											</div>
											<div class="children_cont_items">
												2) Ingresa tu número de teléfono en la pagina de regstración y haz una captura de pantalla.
												(Para ver si se puede registrar con su nuevo numero)
											</div>
										</div>
									</van-collapse-item>
								</van-collapse>
							</div>
						</van-collapse-item>

						<!--<van-collapse-item :border="hasborder" name="5">
							<template #title>
								<div class="common_title_wrap">
									<div class="common_title_left">
										<div class="common_tleft_icon">
											<img v-if="collapseIsOpen('5')" src="../assets/imgs/common_icon_05_active.png" alt="" />
											<img v-else src="../assets/imgs/common_icon_05.png" alt="" />
										</div>
										<div class="common_tleft_text" :class="collapseIsOpen('5') ? 'isopen' : ''">¿Qué es Pla Pla?</div>
									</div>
								</div>
							</template>

							<template #right-icon>
								<div class="common_title_right">
									<div class="common_trview">
										<img v-if="collapseIsOpen('5')" src="../assets/imgs/arrow_icon_up.png" alt="" />
										<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
									</div>
								</div>
							</template>

							<div class="common_children_wrap">
								<div class="children_cont_items">
									<div class="children_cont_text">
										Pla Pla es una plataforma de préstamo personal en línea que forma parte de GRUPO EMPRESARIAL F.CUBE,
										S.A. de C.V., SOFOM, E.N.R. .Nuestro numero de registro CONDUSEF es 695600. Pla Pla ofrece préstamo
										hasta $20000, el proceso de solicitud es sencillo y seguro, con aprobación rápida.
									</div>
								</div>
							</div>
						</van-collapse-item>-->

					</van-collapse>
				</div>
			</div>
		</div>
		<footPage></footPage>
	</div>
	<div v-else class="mobile_viewrap">
		<div class="mobile_wrap">
			<mobNav :activeNav="activeNav"></mobNav>
		</div>
		<div class="mobhome_banner">
			<div class="mobhome_banner_cont">
				<img src="@/assets/mobimg/mob_comproblem_banner.png" />
			</div>
		</div>
		<div class="mobile_common_problem_wrap">
			<div class="common_problem_mobview">
				<van-collapse :border="hasborder" :accordion="isaccordion" v-model="activeNames" @change="collapseChange">
					<van-collapse-item :border="hasborder" name="2">
						<template #title>
							<div class="common_title_wrap">
								<div class="common_title_left">
									<div class="common_tleft_icon">
										<img v-if="collapseIsOpen('2')" src="../assets/imgs/common_icon_02_active.png" alt="" />
										<img v-else src="../assets/imgs/common_icon_02.png" alt="" />
									</div>
									<div class="common_tleft_text_mobile" :class="collapseIsOpen('2') ? 'isopen' : ''">
										Materiales de solicitud
									</div>
								</div>
							</div>
						</template>

						<template #right-icon>
							<div class="common_title_right">
								<div class="common_trview">
									<img v-if="collapseIsOpen('2')" src="../assets/imgs/arrow_icon_up.png" alt="" />
									<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
								</div>
							</div>
						</template>

						<div class="common_children_wrap">
							<div class="children_cont_items">
								<div class="children_cont_text">
									Tener tu INE a la mano y una tarjeta bancaria de cuenta débito de CUALQUIER banco y que esté a TU
									nombre.
								</div>
							</div>
						</div>
					</van-collapse-item>

					<van-collapse-item :border="hasborder" name="3">
						<template #title>
							<div class="common_title_wrap">
								<div class="common_title_left">
									<div class="common_tleft_icon">
										<img v-if="collapseIsOpen('3')" src="../assets/imgs/common_icon_03_active.png" alt="" />
										<img v-else src="../assets/imgs/common_icon_03.png" alt="" />
									</div>
									<div class="common_tleft_text_mobile" :class="collapseIsOpen('3') ? 'isopen' : ''">
										Preguntas de pago
									</div>
								</div>
							</div>
						</template>

						<template #right-icon>
							<div class="common_title_right">
								<div class="common_trview">
									<img v-if="collapseIsOpen('3')" src="../assets/imgs/arrow_icon_up.png" alt="" />
									<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
								</div>
							</div>
						</template>

						<div class="common_children_wrap">
							<van-collapse :border="hasborder" v-model="chidtwo_Names">
								<van-collapse-item :border="hasborder" name="1">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidtwoIsOpen('1')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">¿Cómo pagar préstamo desde la App de su banco?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>

									<div class="children_cont">
										<div class="children_cont_items">1) Abre Pla Pla y copia la referencia de pago en la App.</div>
										<div class="children_cont_items">
											2) Abre la App de tu banco y selecciona una cuenta o tarjeta para pagar.
										</div>
										<div class="children_cont_items">
											3) Ingresa el beneficiario e importe (Recomendamos que guardes contacto para tu próximo préstamo).
										</div>
										<div class="children_cont_items">
											4) ¡Pago exitoso! Puedes volver a Pla Pla y ver el estado de la actualización.
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="2">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidtwoIsOpen('2')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">¿Qué hago cuando mi pago está fallado?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>
									<div class="children_cont">
										<div class="children_cont_items">
											Primero, confirma que la referencia de pago ingresada es correcta. Y si la referencia es correcta
											y tu pago aún no se ve reflejado, por favor, guardan los comprobantes de pago y marca a nuestro
											servicio de atención al cliente 3317133531 o enviarnos un correo electrónico
											plaplaprestamos@gmail.com.
										</div>
									</div>
								</van-collapse-item>
							</van-collapse>
						</div>
					</van-collapse-item>

					<van-collapse-item :border="hasborder" name="4">
						<template #title>
							<div class="common_title_wrap">
								<div class="common_title_left">
									<div class="common_tleft_icon">
										<img v-if="collapseIsOpen('4')" src="../assets/imgs/common_icon_04_active.png" alt="" />
										<img v-else src="../assets/imgs/common_icon_04.png" alt="" />
									</div>
									<div class="common_tleft_text_mobile" :class="collapseIsOpen('4') ? 'isopen' : ''">
										Preguntas en proceso de solicitud
									</div>
								</div>
							</div>
						</template>

						<template #right-icon>
							<div class="common_title_right">
								<div class="common_trview">
									<img v-if="collapseIsOpen('4')" src="../assets/imgs/arrow_icon_up.png" alt="" />
									<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
								</div>
							</div>
						</template>

						<div class="common_children_wrap">
							<van-collapse :border="hasborder" v-model="chidthr_Names">
								<van-collapse-item :border="hasborder" name="1">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidthrIsOpen('1')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">¿Cómo puedo solicitar mi primer préstamo?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>

									<div class="children_cont">
										<div class="children_cont_items">
											Entre a la app, regístrete con tu número telefónico (Le recomendamos crear una contraseña a la
											vez) y empieza a solicitar su préstamo. Después de la autorización, de clic en el botón de
											¨CONFIRMAR¨, el préstamo llegará a tu cuenta bancaria.
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="2">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidthrIsOpen('2')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">¿Cómo puedo solicitar de nuevo un préstamo?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>

									<div class="children_cont">
										<div class="children_cont_items">
											Una vez que se acredite tu pago podrás solicitar un segundo préstamo ¡de inmediato! Y esta vez
											disfrutarás de un monto mayor con un costo menor. Si le rechazaron tu última solicitud, puedes
											volver a solicitar después de 7 días.
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="3">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidthrIsOpen('3')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">¿Puedo tener otro préstamo mientras tengo uno activo?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>

									<div class="children_cont">
										<div class="children_cont_items">
											Lamentablemente no puede pedir otro préstamo mientras tiene uno activo. Deberá liquidar su
											préstamo activo para poder solicitar otro. Eso sí, una vez que liquide, podrá solicitar otro de
											forma inmedia
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="4">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidthrIsOpen('4')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">
													¿Cuanto tiempo tengo para confirmar mi préstamo en la App?
												</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>

									<div class="children_cont">
										<div class="children_cont_items">
											Le quedan 72 horas para confirmar tu préstamo. Le recomendamos dar clic en ¨CONFIRMAR¨ lo antes
											posible.
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="5">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidthrIsOpen('5')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">¿Cuánto tiempo tardan en depositar?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>

									<div class="children_cont">
										<div class="children_cont_items">
											Una vez que está aprobado el depósito se manda en unos minutos, sin embargo, como los horarios
											bancarios en México son de Lunes a Viernes de 9 a 5 (excepto días festivos), el depósito podría
											tardar un poco en reflejarlo en tu cuenta.
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="6">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidthrIsOpen('6')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">
													¿Cómo usan la información que lleno en la solicitud de préstamo?
												</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>

									<div class="children_cont">
										<div class="children_cont_items">
											Pla Pla usa tus datos para determinar si eres candidato a un préstamo de nuestra app. Toda tu
											información se encuentra segura y protegida. Nunca proporcionaremos tu información a terceros sin
											su permiso. Puedes leer nuestro Aviso de Privacidad dentro de la app.
										</div>
									</div>
								</van-collapse-item>
							</van-collapse>
						</div>
					</van-collapse-item>

					<van-collapse-item :border="hasborder" name="1">
						<template #title>
							<div class="common_title_wrap">
								<div class="common_title_left">
									<div class="common_tleft_icon">
										<img v-if="collapseIsOpen('1')" src="../assets/imgs/common_icon_01_active.png" alt="" />
										<img v-else src="../assets/imgs/common_icon_01.png" alt="" />
									</div>
									<div class="common_tleft_text_mobile" :class="collapseIsOpen('1') ? 'isopen' : ''">
										Preguntas generales
									</div>
								</div>
							</div>
						</template>

						<template #right-icon>
							<div class="common_title_right">
								<div class="common_trview">
									<img v-if="collapseIsOpen('1')" src="../assets/imgs/arrow_icon_up.png" alt="" />
									<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
								</div>
							</div>
						</template>

						<div class="common_children_wrap">
							<van-collapse :border="hasborder" v-model="chidone_Names">
								<van-collapse-item :border="hasborder" name="1">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidoneIsOpen('1')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">Me rechazaron mi préstamo, ¿qué hago?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>

									<div class="children_cont">
										<div class="children_cont_items">
											Lamentamos que tu solicitud haya sido rechazada; esto significa que no podrás utilizar nuestros
											servicios por ahora. Normalmente se deben a tres motivos:
										</div>
										<div class="children_cont_items">1) Confirma que todos sus datos son correctos.</div>
										<div class="children_cont_items">2) Tu monto acumulado excede el máximo permitido del mes.</div>
										<div class="children_cont_items">
											3) Tu puntaje de crédito no es suficiente. ¡Pero, no te preocupe! Puede intentar volver a
											solicitar 7 días!
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="2">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidoneIsOpen('2')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">
													Mi solicitud ha sido aprobada en la App, pero el dinero no llegó a mi cuenta bancaria. ¿Qué
													hago?
												</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>
									<div class="children_cont">
										<div class="children_cont_items">
											Las transferencias interbancarias pueden tardar al máximo 20 minutos. Si pasa esta hora y aún no
											ha recibido el préstamo, por favor contáctenos. Daremos prioridad a su consulta y le ayudaremos a
											resolverlo. Gracias por su comprensión y confianza.
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="3">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidoneIsOpen('3')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">
													Realicé el pago, sin embargo, no se ve reflejado en la App. ¿Qué hago?
												</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>
									<div class="children_cont">
										<div class="children_cont_items">
											Hay retraso en transferencia interbancaria, gracias por su paciencia. Pero si pasa UNA HORA y aún
											no se ve reflejado en la App, podrías marcar a la atención al cliente adjuntando tu comprobante de
											pago con clave rastreo.
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="4">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidoneIsOpen('4')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">Accidentalmente pagué en exceso, ¿qué hago?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>
									<div class="children_cont">
										<div class="children_cont_items">
											No te preocupes, el dinero en exceso se depositará automáticamente en el saldo de tu cuenta en Pla
											Pla. Puedes contactar con la atención al cliente para pagar tu próximo préstamo con tu saldo.
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="5">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidoneIsOpen('5')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">Hay falla en la App, ¿qué hago?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>
									<div class="children_cont">
										<div class="children_cont_items">
											Lamentamos que se haya encontrado con este problema. Puede enviar las singientes informaciones al
											correo de atención al cliente para verificar (plaplaprestamos@gmail.com):
										</div>
										<div class="children_cont_items">1) Número telefónico</div>
										<div class="children_cont_items">2) Modelo celular</div>
										<div class="children_cont_items">3) Captura de pantalla del probelma</div>
										<div class="children_cont_items">4) Descripción del problema</div>
										<div class="children_cont_items">
											Agradecemos muchos por sus preguntas, que nos ayudan a seguir mejorando la App y brindarle una
											mejor experiencia.
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="6">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidoneIsOpen('6')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">Quiero cambiar mi cuenta bancaria, ¿qué hago?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>
									<div class="children_cont">
										<div class="children_cont_items">
											Si no tiene ningún pedido pendiente, puede modificar la cuenta bancaria en tres lugares en Pla
											Pla:
										</div>
										<div class="children_cont_items">1)Entrar en la pagina de "Yo", luego da clic en "Mi tarjeta"</div>
										<div class="children_cont_items">2)Entrar en la pagina de "Yo", luego da clic en "Mi perfil"</div>
										<div class="children_cont_items">
											3)Entrar en la pagina de "Confirmar tu prestamo", luego da clic en "Cuenta bancaria"
										</div>
									</div>
								</van-collapse-item>

								<van-collapse-item :border="hasborder" name="7">
									<template #title>
										<div class="children_title_wrap">
											<div class="children_title_left">
												<div class="children_tleft_icon">
													<img v-if="chidoneIsOpen('7')" src="../assets/imgs/arrow_icon_up.png" alt="" />
													<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
												</div>
												<div class="children_tleft_text">Quiero cambiar mi número de teléfono, ¿qué hago?</div>
											</div>
										</div>
									</template>

									<template #right-icon>
										<div class="children_right"></div>
									</template>
									<div class="children_cont">
										<div class="children_cont_items">
											Si quieres cambiar número telefónico, por favor, las sigientes información a la atención al
											cliente:
										</div>
										<div class="children_cont_items">
											1) Fotos de identificación que has subido para registrarte la cuenta Pla Pla (Para verificar si
											eres la misma persona)
										</div>
										<div class="children_cont_items">
											2) Ingresa tu número de teléfono en la pagina de regstración y haz una captura de pantalla. (Para
											ver si se puede registrar con su nuevo numero)
										</div>
									</div>
								</van-collapse-item>
							</van-collapse>
						</div>
					</van-collapse-item>

					<van-collapse-item :border="hasborder" name="5">
						<template #title>
							<div class="common_title_wrap">
								<div class="common_title_left">
									<div class="common_tleft_icon">
										<img v-if="collapseIsOpen('5')" src="../assets/imgs/common_icon_05_active.png" alt="" />
										<img v-else src="../assets/imgs/common_icon_05.png" alt="" />
									</div>
									<div class="common_tleft_text_mobile" :class="collapseIsOpen('5') ? 'isopen' : ''">
										¿Qué es Pla Pla?
									</div>
								</div>
							</div>
						</template>

						<template #right-icon>
							<div class="common_title_right">
								<div class="common_trview">
									<img v-if="collapseIsOpen('5')" src="../assets/imgs/arrow_icon_up.png" alt="" />
									<img v-else src="../assets/imgs/arrow_icon_down.png" alt="" />
								</div>
							</div>
						</template>

						<div class="common_children_wrap">
							<div class="children_cont_items">
								<div class="children_cont_text">
									Pla Pla es una plataforma de préstamo personal en línea que forma parte de GRUPO EMPRESARIAL F.CUBE,
									S.A. de C.V., SOFOM, E.N.R. .Nuestro numero de registro CONDUSEF es 695600. Pla Pla ofrece préstamo
									hasta $20000, el proceso de solicitud es sencillo y seguro, con aprobación rápida.
								</div>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>
		</div>

		<mobFooter></mobFooter>
	</div>
</template>

<script>
	import headNav from '@/components/headNav.vue'
	import homeNav from '@/components/homeNav.vue'
	import footPage from '@/components/foot.vue'
	import '../components/scss/ayuda.scss'
	import mobNav from '@/components/mobNav.vue'
	import mobFooter from '@/components/mobfooter.vue'
	import mobileOrpc from '@/mixins/index'

	export default {
		name: 'ayuda',
		components: { headNav, homeNav, footPage, mobNav, mobFooter },
		mixins: [mobileOrpc],
		data() {
			return {
				activeNav: '',
				isaccordion: true,
				hasborder: false,
				activeNames: [],
				chidone_Names: [],
				chidtwo_Names: [],
				chidthr_Names: [],
				chidfur_Names: [],
				chidfiv_Names: [],
				scroll: 0,
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			document.body.scrollTop = document.documentElement.scrollTop = 0
		},
		watch: {
			changeBtn() {
				this.activeNames = []
			},
		},
		methods: {
			handleScroll() {
				//或者使用document.querySelector('.class或者#id').scrollTop
				this.scroll = document.documentElement.scrollTop || document.body.scrollTop
			},
			handleChange() {
				console.log(this.activeNames)
			},
			changeCont(id) {
				this.changeBtn = id
			},
			collapseIsOpen(index) {
				let useActiveNames = this.activeNames
				let isOpen = useActiveNames.indexOf(index)

				if (isOpen == -1) {
					return false
				} else {
					return true
				}
			},
			chidoneIsOpen(index) {
				let useActiveNames = this.chidone_Names
				let isOpen = useActiveNames.indexOf(index)

				if (isOpen == -1) {
					return false
				} else {
					return true
				}
			},
			chidtwoIsOpen(index) {
				let useActiveNames = this.chidtwo_Names
				let isOpen = useActiveNames.indexOf(index)

				if (isOpen == -1) {
					return false
				} else {
					return true
				}
			},
			chidthrIsOpen(index) {
				let useActiveNames = this.chidthr_Names
				let isOpen = useActiveNames.indexOf(index)

				if (isOpen == -1) {
					return false
				} else {
					return true
				}
			},
			chidfurIsOpen(index) {
				let useActiveNames = this.chidfur_Names
				let isOpen = useActiveNames.indexOf(index)

				if (isOpen == -1) {
					return false
				} else {
					return true
				}
			},
			chidfivIsOpen(index) {
				let useActiveNames = this.chidfiv_Names
				let isOpen = useActiveNames.indexOf(index)

				if (isOpen == -1) {
					return false
				} else {
					return true
				}
			},
			collapseChange(e) {
				console.log(e)
			},
		},
		//销毁,否则跳到别的路由还是会出现
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll)
		},
	}
</script>

<style>
	.ayuda {
		min-height: 100vh;
		flex-direction: column;
		display: flex;
		background: #fbfbfb;
	}
	.answer span {
		font-weight: 700;
	}

	button {
		display: inline-block;
		padding: 12px 34px;
		font-weight: 400;
		border: none;
		color: #333333;
		background: #fff;
		cursor: pointer;
		font-size: 18px;
		border-radius: 24px;
		border: 1px solid #ffffff;
		box-shadow: 0px 2px 11px 0px #e7e6e6;
	}
	.is-active button {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		background: #fff9f5;
		border: 1px solid #e6996b;
		/*box-shadow: 0px 25px 50px 0px rgba(69,69,69,0.06);*/
		color: #e6996b;
		font-weight: 600;
	}
	ul {
		list-style: none;
	}

	.van-cell {
		background-color: #13151a !important;
	}
	.van-collapse-item {
		background-color: #0a0b0e !important;
	}
	.van-cell--clickable:active {
		background-color: #0a0b0e !important;
	}
	.van-collapse-item__content {
		padding: 0;
		background-color: #13151a !important;
	}
	.common_problem_wrap {
		width: 1300px;
		padding-top: 0.26rem;
		margin: 0 auto;
	}
	.common_title_wrap {
		width: 100%;
		height: 1.222222rem;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		padding: 0 0 0 0.694444rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.common_title_left {
		width: auto;
		height: 0.666667rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.common_tleft_icon {
		width: 0.666667rem;
		height: 0.666667rem;
	}
	.common_tleft_icon img {
		display: block;
		width: 100%;
	}
	.common_tleft_text {
		width: auto;
		padding-left: 0.277778rem;
		font-size: 0.388889rem;
		font-family: SFProDisplay-Regular, SFProDisplay;
		font-weight: 400;
		color: #8c8e94;
	}
	.common_title_left .isopen {
		color: #ffffff;
	}
	.common_title_right {
		width: auto;
		height: 1.222222rem;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		box-sizing: border-box;
		padding-right: 0.833333rem;
	}
	.common_trview {
		width: 0.277778rem;
		height: 0.277778rem;
	}
	.common_trview img {
		display: block;
		width: 100%;
	}
	.common_children_wrap {
		width: 100%;
		box-sizing: border-box;
		padding-left: 0.555556rem;
		padding-bottom: 0.75rem;
	}
	.children_title_wrap {
		width: 100%;
		height: auto;
		padding-top: 0.555556rem;
		background: #0a0b0e;
	}
	.children_title_left {
		width: 100%;
		height: auto;
		display: flex;
		justify-content: flex-start;
	}
	.children_tleft_icon {
		width: 0.5rem;
		height: 0.472222rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.children_tleft_icon img {
		display: block;
		width: 0.277778rem;
		height: 0.277778rem;
	}
	.children_tleft_text {
		width: 100%;
		height: auto;
		box-sizing: border-box;
		padding-right: 1.055556rem;
		font-size: 0.333333rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(255, 255, 255, 0.86);
		line-height: 0.472222rem;
	}
	.children_cont {
		width: 100%;
		height: auto;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		padding: 0.222222rem 1.055556rem 0 0.472222rem;
		overflow-y: scroll;
	}
	.children_cont_items {
		width: 100%;
		height: auto;
		font-size: 0.277778rem;
		font-weight: bold;
		color: #8c8e94;
		line-height: 0.555556rem;
	}
	.common_children_wrap .van-cell {
		width: 96%;
		background-color: #0a0b0e !important;
	}
	.common_children_wrap .van-collapse-item {
		background-color: #0a0b0e !important;
	}
	.common_children_wrap .van-collapse-item__content {
		background-color: #0a0b0e !important;
	}
	.common_children_wrap .van-collapse {
		width: 96%;
		padding-bottom: 30px;
		background-color: #0a0b0e !important;
	}
	.common_children_wrap .van-cell--clickable:active {
		background-color: #0a0b0e !important;
	}

	.children_cont_text {
		width: 96%;
		box-sizing: border-box;
		padding: 0.222222rem 1.055556rem 0.222222rem 0.472222rem;
		background: #0a0b0e;
	}
	.pla_about_wrap {
		background: #13151a;
		padding-bottom: 60px;
	}
	.mobile_common_problem_wrap {
		width: 100%;
	}
	.common_problem_mobview {
		width: 100%;
		padding-top: 0.26rem;
		margin: 0 auto;
	}
	.mobile_viewrap .children_cont_items {
		font-weight: normal;
	}
	.mobile_viewrap .common_title_wrap {
		padding-left: 0;
	}
	.mobile_viewrap .common_title_right {
		padding-right: 0;
	}

	.common_tleft_text_mobile {
		width: auto;
		padding-left: 0.277778rem;
		font-size: 0.388889rem;
		font-weight: 400;
		color: #8c8e94;
	}
</style>
